import Box from '@mui/material/Box'
import React from 'react'
import { Document, Page, pdfjs } from 'react-pdf'

import type { SxProps, Theme } from '@mui/material/styles'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const PAGE_NUMBER = 1
const noop = () => undefined

type RenderExceptionContentProps = {
  height?: string | number
  src?: string
  isPdf?: boolean
  sx?: SxProps<Theme>
  PageProps?: Record<string, unknown>
  [key: string]: unknown
}

const RenderExceptionContent = ({ height = '194px', src, isPdf, sx, PageProps, ...rest }: RenderExceptionContentProps) => {
  if (isPdf) {
    return (
      <Box
        sx={{
          display: 'flex',
          // Same fixed media height as photos so signature/PDF slides don't collapse the card.
          alignItems: 'center',
          height,
          overflow: 'hidden',
          justifyContent: 'center',
          width: '100%',
          objectFit: 'cover',
          bgcolor: 'grey.100',
          ...sx,
        }}
        {...rest}
      >
        <Document border={0} file={src} style={{ ...(sx as React.CSSProperties) }} onLoadSuccess={noop}>
          <Page pageNumber={PAGE_NUMBER} {...PageProps} />
        </Document>
      </Box>
    )
  }
  return (
    <Box
      component="img"
      src={src}
      sx={{
        // cover, not contain, so photos never letterbox; block kills the img baseline seam under the slide.
        bgcolor: 'grey.100',
        display: 'block',
        height,
        objectFit: 'cover',
        width: '100%',
        ...sx,
      }}
      {...rest}
    />
  )
}

export default RenderExceptionContent
